/**
 * Glue the trader family shares without importing each other (trader.ts and
 * llama.ts would otherwise be a cycle): the live mob list, a sound hook and the
 * registry of traders that despawned (their llamas leave with them).
 * TraderSystem fills it in; unit tests may leave the defaults.
 */

import type { Mob } from '../mob';

export const traderHooks: {
  mobs: () => readonly Mob[];
  sound: ((id: string, x: number, y: number, z: number) => void) | null;
} = { mobs: () => [], sound: null };

/** Traders (by uid) that despawned for good this session: trader llamas holding their uid vanish too. */
export const vanishedTraders = new Set<number>();

export const playSound = (id: string, m: { x: number; y: number; z: number }): void => traderHooks.sound?.(id, m.x, m.y + 1, m.z);

/** The live trader with this uid, or null. */
export function traderByUid(uid: number): (Mob & { uid: number }) | null {
  if (!uid) return null;
  for (const m of traderHooks.mobs()) if (m.type === 'wandering_trader' && !m.removed && (m as Mob & { uid: number }).uid === uid) return m as Mob & { uid: number };
  return null;
}
